/*
 *  exception路由
 * */

export default [{
  path: '/',
  redirect: '/home',
  isTab: false
}, {
  name: "404",
  path: "*",
  // redirect: '/refund-process/financial-refund-check',
  meta: {
    title: "404",
    menu: "/404",
    isTab: false
  },
  component: () => import( /* webpackChunkName: 'warehouse-space' */ '@/views/exception/404'),
}];
